import { getJson, postJson } from '../fetch';
import API_BASE_PATH from './basePath';

export const getFeedback = (surveyType) => getJson(`${API_BASE_PATH}/survey-feedback?surveyType=${surveyType}`);

export const postUserFeedback = (message) => postJson(`${API_BASE_PATH}/user-feedback/`, { message });
